<section *ngIf="!ongoingRequest" class="m-t-24" [ngClass]="IsMobile ? 'widt' : ''">
    <div class="span-end">
        <div *ngIf="!IsMobile && pricingPlanData?.currentPricingPlan " [ngClass]="IsMobile ? '' : 'web-card'">
            <section>
                <h3 class="m-b-18 title">
                    Pricing Details
                </h3>
                <app-pricing-list [pricingData]="pricingPlanData?.currentPricingPlan"></app-pricing-list>
            </section>
        </div>
        <div class="button-con">
            <div *ngIf="AllowedAccess">
                <app-custom-submit-button *ngIf="!fixedPricing" (submitForm)="requestFixedPricing()" [block]="true"
                    class="btn btn-block" name="Request Fixed Pricing">
                </app-custom-submit-button>
                <app-custom-submit-button *ngIf="fixedPricing" (submitForm)="requestFixedPricing()" [block]="true"
                    class="btn btn-block" name="Edit Fixed Pricing">
                </app-custom-submit-button>
            </div>
            <div *ngIf="IsMobile && pricingPlanData?.currentPricingPlan">
                <div (click)="openPricingInfo()" style="text-align: center;" class="purchase-cancel addCursor m-t-26">
                    See Pricing Details </div>
            </div>
        </div>
    </div>
</section>


<section *ngIf="ongoingRequest" [ngClass]="IsMobile ? 'width' : ''">
    <nz-layout>
        <nz-content>
            <div [ngClass]="IsMobile ? '' : 'web-card'">
                <div *ngIf="!fixedPricing" class="header">
                    <h3 class="title m-0">
                        Pricing Model:
                    </h3>
                    <p class="m-0">
                        <span class="tag-active">
                            <svg width="13" height="14" viewBox="0 0 13 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.49532 10.436L1.60846 10.5495L1.72173 10.4362L5.15443 7.00349L7.14872 8.99657L7.26186 9.10964L7.37496 8.99654L11.9415 4.43003L12.0545 4.31703L11.9416 4.20389L11.4033 3.66434L11.2902 3.55094L11.1769 3.66421L7.26179 7.57933L5.2675 5.58624L5.15436 5.47317L5.04126 5.58628L0.957175 9.67036L0.844171 9.78336L0.957042 9.8965L1.49532 10.436Z"
                                    fill="#1EB12D" stroke="#1EB12D" stroke-width="0.32" />
                                <path d="M11.9404 6.90332H11.1787V4.42773H8.70312V3.66602H11.9404V6.90332Z"
                                    fill="#1EB12D" />
                            </svg>

                            PERFORMANCE BASED
                        </span>
                    </p>
                </div>
                <div *ngIf="fixedPricing" class="header">
                    <h3 class="title m-0">
                        Pricing Model:
                    </h3>
                    <p class="m-0">
                        <span class="tag-fixed">
                            <svg width="13" height="14" viewBox="0 0 13 14" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.2502 6.35078V5.05078C3.2502 3.25586 4.70527 1.80078 6.5002 1.80078C8.29512 1.80078 9.7502 3.25586 9.7502 5.05078V6.35078C10.4682 6.35078 11.0502 6.93281 11.0502 7.65078V10.9008C11.0502 11.6188 10.4682 12.2008 9.7502 12.2008H3.2502C2.53223 12.2008 1.9502 11.6188 1.9502 10.9008V7.65078C1.9502 6.93281 2.53223 6.35078 3.2502 6.35078ZM8.4502 5.05078V6.35078H4.5502V5.05078C4.5502 3.97383 5.42324 3.10078 6.5002 3.10078C7.57715 3.10078 8.4502 3.97383 8.4502 5.05078Z"
                                    fill="#9B51E0" />
                            </svg>


                            FIXED
                        </span>
                    </p>
                </div>
                <div *ngIf="fixedPricing" class="header m-t-16">
                    <h3 class="title m-0">
                        Pricing Plan:
                    </h3>
                    <p class="m-0 pricing-plan-title">
                        {{pricingPlanData.pendingPricingPlanRequest.name}}
                    </p>
                </div>
                <div class="m-t-20 m-b-20">
                    <div class="pos-action-divider"></div>
                </div>
                <section>
                    <h3 class="m-b-18 title">
                        Pricing Details
                    </h3>
                    <app-pricing-list [pricingData]="pricingPlanData?.pendingPricingPlanRequest"></app-pricing-list>
                </section>
            </div>
        </nz-content>
    </nz-layout>
</section>